export interface INDISpecial {
  id: number;
  sku: string;
  creationDate?: string;
  creationBy: string;
  supplier: string;
  description: string;
  class2: string;
  supplierSKU: string;
  purchasePrice?: number;
  supplierPrice?: number;
  salesPrice?: number;
  orderUnit: number;
  deliveryDays: number;
}

export const EmptyINDISpecial = (): INDISpecial => ({
  id: 1,
  sku: '',
  creationBy: '',
  supplier: 'SUPPLIER_INDI',
  description: '',
  class2: '',
  supplierSKU: '',
  orderUnit: 1,
  deliveryDays: 0,
});
